import "./styles.scss";

import * as React from "react";
import { Button, Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, NavLink } from "react-router-dom";
import { UserI } from "../../../types";
import { useEffect, useState } from "react";

export const NavigationTop: React.FC<{ user?: UserI | null }> = (props) => {
    const { user } = props;

    const { t, i18n } = useTranslation();

    const [loginTitle, setLoginTitle] = useState<string>(
        t("Log-in").toString()
    );
    const [navbarExpanded, setNavbarExpanded] = useState<boolean>(false);

    const toggleNavbar = () => {
        setNavbarExpanded(!navbarExpanded);
    };

    const toggleLanguage = (language: string) => {
        i18n.changeLanguage(language);
        setNavbarExpanded(false);
    };

    useEffect(() => {
        setLoginTitle(
            user
                ? user.nickname !== ""
                    ? user.nickname
                    : user.name !== ""
                    ? user.name
                    : user.email
                : t("Log-in").toString()
        );
    }, [user, t]);

    return (
        <Navbar
            bg={"primary"}
            expand={"lg"}
            fixed={"top"}
            className={"navigation-top"}
            variant={"dark"}
            expanded={navbarExpanded}
            onToggle={toggleNavbar}
        >
            <Container>
                <Link className={"navbar-brand"} to={"/"}>
                    Retro Games Slovakia
                </Link>

                <Navbar.Toggle aria-controls={"navigation-top"} />

                <Navbar.Collapse id={"navigation-top"}>
                    <Nav className={"me-auto"}>
                        <NavLink
                            className={"nav-link"}
                            to={"/games"}
                            onClick={toggleNavbar}
                        >
                            {t("Games")}
                        </NavLink>

                        {user && user.role === "admin" ? (
                            <NavDropdown
                                title={t("Administration")}
                                id={"administration-nav-dropdown"}
                            >
                                <NavLink
                                    className={"dropdown-item"}
                                    to={"/administration/game/add"}
                                    onClick={toggleNavbar}
                                >
                                    {t("Add Game")}
                                </NavLink>
                            </NavDropdown>
                        ) : null}

                        <NavDropdown
                            title={loginTitle}
                            id={"login-nav-dropdown"}
                        >
                            {user ? (
                                <NavLink
                                    className={"dropdown-item"}
                                    to={"/logout"}
                                    onClick={toggleNavbar}
                                >
                                    {t("Log-out")}
                                </NavLink>
                            ) : (
                                <NavLink
                                    className={"dropdown-item"}
                                    to={"/login"}
                                    onClick={toggleNavbar}
                                >
                                    {t("Log-in")}
                                </NavLink>
                            )}
                        </NavDropdown>

                        <NavDropdown
                            title={
                                i18n.language === "sk"
                                    ? t("Slovak")
                                    : t("English")
                            }
                            id={"change-language-nav-dropdown"}
                        >
                            {i18n.language === "sk" ? (
                                <Button
                                    className={"dropdown-item"}
                                    onClick={() => toggleLanguage("en")}
                                >
                                    {t("English")}
                                </Button>
                            ) : (
                                <Button
                                    className={"dropdown-item"}
                                    onClick={() => toggleLanguage("sk")}
                                >
                                    {t("Slovak")}
                                </Button>
                            )}
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};
